import React from 'react'
import cx from 'classnames'

import { Field } from './common/Field/Field'

import styles from './Form.module.scss'

export const Form = ({ children, className = undefined }) => (
  <form className={cx(styles.form, { [className]: Boolean(className) })}>
    {children}
  </form>
)

Form.Field = Field
